export function formatTime(iso,type) {
    if (!iso) return '--';
    const d = new Date(iso);
    const Y = d.getFullYear();
    const M = String(d.getMonth() + 1).padStart(2, '0');
    const D = String(d.getDate()).padStart(2, '0');
    if(type === 'yyyy-MM-dd'){
        return `${Y}-${M}-${D}`;
    }
    if(type === 'yyyy-MM'){
        return `${Y}-${M}`;
    }
    if(type === 'MM-dd'){
        return `${M}-${D}`;
    }
    if(type === 'yyyy'){
        return `${Y}`;
    }
    if(type === 'MM'){
        return `${M}`;
    }
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    const s = String(d.getSeconds()).padStart(2, '0');
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  }